module.exports = __webpack_public_path__ + "img/army_of_the_underworld.89db7197.jpg";